export function Pause({ width = 16 }: { width?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 384 512"
      width={width}
      fill="none"
    >
      <path
        d="M48 64c-8.8 0-16 7.2-16 16l0 352c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-352c0-8.8-7.2-16-16-16L48 64zM0 80C0 53.5 21.5 32 48 32l64 0c26.5 0 48 21.5 48 48l0 352c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48L0 80zM272 64c-8.8 0-16 7.2-16 16l0 352c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-352c0-8.8-7.2-16-16-16l-64 0zM224 80c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 352c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-352z"
        fill="currentColor"
      />
    </svg>
  );
}
